export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/accounts": [3],
		"/accounts/new": [6],
		"/accounts/[id]": [4],
		"/accounts/[id]/contracts/new": [5],
		"/admin": [7],
		"/admin/dojo/contract-template": [8],
		"/admin/dojo/edit": [9],
		"/admin/programs/new": [20],
		"/admin/programs/[programId]/courses": [10],
		"/admin/programs/[programId]/courses/new": [12],
		"/admin/programs/[programId]/courses/[courseId]": [11],
		"/admin/programs/[programId]/edit": [13],
		"/admin/programs/[programId]/rank-systems": [14],
		"/admin/programs/[programId]/rank-systems/new": [16],
		"/admin/programs/[programId]/rank-systems/[systemId]": [15],
		"/admin/programs/[programId]/ranks": [17],
		"/admin/programs/[programId]/ranks/new": [19],
		"/admin/programs/[programId]/ranks/[rankId]": [18],
		"/admin/users": [21],
		"/admin/users/new": [23],
		"/admin/users/[id]/permissions": [22],
		"/attendance": [24],
		"/checkin": [25],
		"/checkin/[program]/[courseId]": [26],
		"/classes": [27],
		"/classes/[program]/[courseId]": [28],
		"/enroll": [29],
		"/home": [30],
		"/login": [31],
		"/login/forgot-password": [32],
		"/login/reset-password": [33],
		"/profile": [34],
		"/profile/edit": [35],
		"/profile/sessions": [36],
		"/reports/absence": [37],
		"/reports/anniversary": [38],
		"/reports/attendance": [39],
		"/reports/best-attendance": [40],
		"/reports/birthday": [41],
		"/reports/last-promotion": [42],
		"/reports/student-pin": [43],
		"/students": [44],
		"/students/[id]": [45],
		"/students/[id]/edit": [46],
		"/students/[id]/enrollments/new": [48],
		"/students/[id]/enrollments/[program]": [47]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';